import React from 'react';
import {View} from 'react-native';
import {makeStyles} from '@rn-vui/themed';
import {observer} from 'mobx-react-lite';

import {Icon} from '../../../components/Icon';
import Button from '../../../components/themed/Button';
import Text from '../../../components/themed/Text';
import {useStores} from '../../../stores/use-stores';

import CouponStatusIcon from './CouponStatusIcon';
import CouponStatusPanel from './CouponStatusPanel';

type CartCouponProps = {
  onCouponPress?: () => void;
};

const CartCoupon = observer(({onCouponPress}: CartCouponProps) => {
  const {cartStore} = useStores();
  const styles = useStyles();

  return (
    <View>
      <Button
        containerStyle={{marginVertical: 0}}
        buttonStyle={{
          justifyContent: 'space-between',
          flexDirection: 'row',
          alignItems: 'center',
          backgroundColor: 'transparent',
        }}
        type="clear"
        onPress={onCouponPress}>
        {!!cartStore.currentOrder?.coupon_code && (
          <View testID="coupon-code-row" style={styles.codeRow}>
            <CouponStatusIcon />
            <Text adjustsFontSizeToFit numberOfLines={1} style={styles.secondLine}>
              {cartStore.currentOrder?.coupon_code}
            </Text>
          </View>
        )}
        {!cartStore.currentOrder?.coupon_code && (
          <Text style={styles.couponText}>ADD COUPON CODE</Text>
        )}
        <Icon
          name={cartStore.currentOrder?.coupon_code ? 'pen' : 'plus'}
          color={styles.iconStyle.color}
          style={{marginLeft: 8}}
        />
      </Button>
      <CouponStatusPanel />
    </View>
  );
});

const useStyles = makeStyles(theme => {
  return {
    couponText: {
      color: theme.colors?.primary,
      fontWeight: '600',
      fontSize: 16,
      textAlign: 'left',
    },
    codeRow: {
      flexDirection: 'row',
      alignItems: 'center',
      flexShrink: 1,
    },
    secondLine: {
      color: theme.colors?.primary,
      fontWeight: '600',
      fontSize: 16,
      textAlign: 'center',
    },
    iconStyle: {
      color: theme.colors?.primary,
      marginLeft: 8,
    },
  };
});

export default CartCoupon;
